export interface IUser {
    id: number,
    firstName: string,
    lastName: string,
    username: string,
    photoUrl: string,
    score: number
}



export interface IGameInfo {
    user: IGameUser,
    hitStreak: number,
    itemOptions: [
        {
            name: string,
            visible: boolean,
            speed: number,
        }
    ] | []
}

export interface IGameUser {
    id: number,
    energy: number,
    dailyEnergy: number,
    totalShoots: number,
    score: number,
    daysGameStreak:number,
    currentStreak: number,
    accurateRate: number,
    wheel: number,
    goldenScore: number,
    wheelRemainingTime: string,
    energyRemainingTime: string,
    isNewUser: boolean,
    distribution: {
        isDistribution: boolean,
        endDistributionAt: string
    },
    boughtItems: IBought,
}
export type IBought = Record<string, IBoughtItem>;

interface IBoughtItem {
    level: number,
    bought: boolean,
    nextRebuyAt: string | null,
    remainingHits: number | null
}


export interface ILeague {
    from: number,
    to: number,
    text: string,
    type: leagueType
}

export enum leagueType {
    Bronze = 'Bronze',
    Silver = 'Silver',
    Gold = 'Gold'
}
